import {AvailabilityCar, Location, LocPaiement} from '@/shared/models';
import {AVAIL_DATE_TIME_FORMAT} from "@/shared/data";
import moment from 'moment';

const LOCATIONS_URI = '/p/api/v1/loc';
const BOOK_URI = '/api/v1/loc/book';
const PAIEMENTS_URI = '/api/v1/paiements';
const PRODUITS_URI = '/p/api/products';

export const LocationsApi =  {
    async findAvailCars(avail) {
        const startTime = moment(avail.startTime).format(AVAIL_DATE_TIME_FORMAT);
        const endTime = moment(avail.endTime).format(AVAIL_DATE_TIME_FORMAT);
        const response = await axios.post(`${LOCATIONS_URI}/prices`, { startTime, endTime, localisation: avail.localisation,carCategories:avail.carCategories });
        return response.data.map(d => new AvailabilityCar(d));
    },
    async book(bookingContext, avail){
        // fixeme problem with date handling in back
        const availabilityCar = JSON.parse(JSON.stringify(bookingContext.availabilityCar));
        availabilityCar.registrationDate = bookingContext.availabilityCar.registrationDate.getTime();
        const availability = JSON.parse(JSON.stringify(avail));
        availability.startTime = avail.startTime.getTime();
        availability.endTime = avail.endTime.getTime();
        availabilityCar.availability = availability;
        const response = await axios.post(`${BOOK_URI}`, availabilityCar);
        return response.data.number;
    },
    async myLocations() {
        const response = await axios.get('/api/v1/locations');
        console.log(response.data);
        return response.data.map(d => new Location(d));
    },
    async getLocationDetails(id){
        const response = await axios.get(`/api/v1/location?id=${id}`);
        console.log(response.data);
        return new Location(response.data);
    },
    async getLocPaiements(locationId){
        const response = await axios.get(`${PAIEMENTS_URI}?locationId=${locationId}`);
        return response.data.content.map(d => new LocPaiement(d));
    },
    async getOptionsProducts(tenantName){
        const response = await axios.get(`${PRODUITS_URI}?tenantName=${tenantName}`);
        return response.data;
    }
};
